import { formatUptimePercent } from "@/v2-status-client/status/status.utils"

export type StatusSummaryUptimeProps = {
  uptimePercent30d: number
}

// 30-day pooled uptime % shown to the right of the history strip.
// Tiny standalone block so we can hide it cleanly when the value
// is null (no data yet) -- rendering "—" there clutters the row
// without telling the customer anything actionable.
function StatusSummaryUptime(props: Readonly<StatusSummaryUptimeProps>) {
  return (
    <div className="flex flex-col items-end shrink-0 text-right">
      <div className="text-sm font-semibold tabular-nums text-foreground">
        {formatUptimePercent(props.uptimePercent30d)}
      </div>
      <div className="text-[10px] uppercase tracking-wide text-muted-foreground">
        uptime · 30 days
      </div>
    </div>
  )
}

export default StatusSummaryUptime
